export function obterListaFinalidadeEmissao() {
  return (
    [
      { label: 'Normal', value: 'NORMAL' },
      { label: 'Complementar', value: 'COMPLEMENTAR' },
      { label: 'Ajuste', value: 'AJUSTE' },
      { label: 'Devolução', value: 'DEVOLUCAO' },
      { label: 'Nota de Crédito', value: 'NOTACREDITO' },
      { label: 'Nota de Débito', value: 'NOTADEBITO' },
    ]
  );
}
